/* v95.5 16 Oct: the new pwg loop stack. Every expression is a real green-screen loop now (tilt, gasp, guilty, wiggle,
   sneeze, mic; blink, side-eye, eye-roll, sigh, nod). Loops without a still play straight away; the empty space
   under the paws is measured off the first frame. Seasonal costumes (Halloween to 31 Oct, Thanksgiving to the
   holiday, Christmas after) take over about half of the appearances. */
/* v66 6 Oct: mascots calmed. Static PNG poses and signs retired.
   Product pages: never on phones/touch; desktop max 1 per view, not before 20s, only every 3rd product view, never over add to cart.
   Other pages: about half as often; phones max 1 per session. */
/* PW CAST ENGINE v2.2 (1 Oct 2026)
   Lines are data: [who, pose, text]. who: r = Rusty, c = Cash, b = banter pair. */
(function () {
  'use strict';
  var root = document.getElementById('pw-cast');
  if (!root) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  try { if (sessionStorage.getItem('pw-peek-off')) { root.remove(); return; } } catch (e) {}

  var PDP = root.getAttribute('data-template') === 'product';
  var MOB = matchMedia('(max-width: 760px), (pointer: coarse)').matches;
  if (PDP && MOB) { root.remove(); return; }
  try {
    if (MOB && sessionStorage.getItem('pw-m-shown')) { root.remove(); return; }
    if (PDP) { var pv = +(sessionStorage.getItem('pw-pdp-n') || 0) + 1; sessionStorage.setItem('pw-pdp-n', pv); if (pv % 3 !== 1) { root.remove(); return; } }
  } catch (e) {}
  var CDN = root.getAttribute('data-cdn');
  var POSES = window.PW_CAST_POSES || {};

  /* ---------- SEASON (costume loops) ---------- */
  var SEA = (function () {
    var d = new Date(), m = d.getMonth(), dt = d.getDate();
    if (m === 9) return 'halloween';
    if (m === 10) { var tg = 22 + ((11 - new Date(d.getFullYear(), 10, 1).getDay()) % 7); return dt <= tg ? 'thanksgiving' : 'christmas'; }
    if (m === 11) return 'christmas';
    return '';
  })();

  /* ---------- LINE DATABASE ---------- */
  var L = {
    any: [
      ['r','grin','Hi! Hi. Hello. Hi.'],
      ['r','grin','I was told to supervise. I have forgotten what.'],
      ['r','tilt','Is this the shop? I thought this was the snack aisle.'],
      ['r','guilty','I licked the screen. Sorry. Carry on.'],
      ['r','tilt','I missed the meeting. Was it about me?'],
      ['r','gasp','Every single thing here is my favorite. I checked.'],
      ['r','wiggle','Cash says I cannot recommend things. I recommend everything.'],
      ['r','tilt','Scroll faster! No, slower. No, I lost it.'],
      ['r','guilty','I am not allowed near the checkout. Long story.'],
      ['r','grin','You look like someone who deserves a blanket.'],
      ['r','sneeze','Sorry. Dust. Or glitter. It is always glitter.'],
      ['r','gasp','A customer! Cash! CASH! A real one!'],
      ['r','guilty','If anyone asks, I was never here.'],
      ['r','tilt','What does bespoke mean? I asked for a snack. Nothing.'],
      ['r','wiggle','I have been employee of the month since I made the award.'],
      ['r','guilty','I chewed one of the tags. It still works. Probably.'],
      ['r','tilt','Do you want to see a trick? I do not know any tricks.'],
      ['r','gasp','You scrolled! I love scrolling!'],
      ['r','wiggle','My job is morale. I am doing great at it.'],
      ['r','sneeze','Bless me. Nobody else was going to.'],
      ['c','sus','Take your time. I have nowhere to be. Literally nowhere.'],
      ['c','blink','I am not going to say anything.'],
      ['c','roll','Fine.'],
      ['c','scheme','I have a plan. It is not going well.'],
      ['c','roll','Rusty was supposed to be here. Rusty is never here.'],
      ['c','alarm','I ran the numbers. The numbers came back concerned.'],
      ['c','palm','I owned a chair once. It ended badly.'],
      ['c','sus','You are browsing like someone with a budget. Respect.'],
      ['c','scheme','Between us, the good stuff is further down.'],
      ['c','roll','Yes, he works here. No, I cannot explain it.'],
      ['c','palm','Rusty ate the meeting agenda. We are winging it.'],
      ['c','sus','I have been watching you scroll. Professionally.'],
      ['c','sus','We are not actual wolves. Please stop asking.'],
      ['c','roll','That is the price. I did not set the price.'],
      ['c','nod','Good taste. I noticed. I notice everything.'],
      ['b','','Cash, can I have a raise?|You are not paid.'],
      ['b','','Cash! I sold a blanket!|You bought a blanket. From us. With my card.'],
      ['b','','Is the customer always right?|The customer is always right. You are never right.'],
      ['b','','I made a plan!|Your plan is to lie down.'],
      ['b','','I love it here!|He says that everywhere. He said it at the vet.'],
      ['b','','Guess who organized the shelves!|That explains the shelves.'],
      ['b','','I learned a new word! Inventory!|He thinks inventory is a type of snack.'],
      ['b','','Can I push the big button?|No.']
    ],
    home: [
      ['r','gasp','Welcome! Wipe your paws! I never do.'],
      ['c','sus','Welcome. Oddly specific gifts. Reasons still pending.'],
      ['r','wiggle','This is the front page! I am in charge of the front page. Nobody told me that.']
    ],
    idle: [
      ['r','tilt','Are you still there? Should I bark? I am going to bark.'],
      ['r','tilt','You stopped. I will also stop. We are resting together.'],
      ['c','blink','You have been on this page a while now.'],
      ['c','roll','Blink twice if you need help deciding.'],
      ['c','palm','He fell asleep on the keyboard again. Ignore any typos.']
    ],
    deep: [
      ['r','gasp','You found the bottom! Nobody finds the bottom!'],
      ['r','wiggle','Keep going, there is more! I think. I have never been down here.'],
      ['c','nod','Thorough. I respect a thorough browser.'],
      ['c','scheme','Most people give up by now. You are not most people.']
    ],
    back: [
      ['r','gasp','You came back! I knew you would. I did not know. I hoped.'],
      ['c','blink','Welcome back. Nothing has changed. I checked.'],
      ['c','roll','We saved your spot. By doing nothing.']
    ],
    returning: [
      ['r','wiggle','It is you again! My favorite person this week!'],
      ['c','sus','Back again. Either you like it here or you left something in your cart.']
    ],
    atc: [
      ['r','gasp','YES! Great pick! I would have picked it too! I pick everything!'],
      ['r','wiggle','It is in the cart! I heard it land!'],
      ['c','nod','Good. Now do not look at the price again. It does not help.'],
      ['c','nod','Excellent decision. I would say that regardless, but this time I mean it.']
    ],
    cart: [
      ['c','sus','Something in your cart is getting comfortable.'],
      ['c','scheme','Free shipping, by the way. I fought for that. Mildly.'],
      ['c','sus','It ships from the USA. I checked the map. Twice.'],
      ['c','roll','Rusty is not allowed in here. He tries to lie down in the cart.'],
      ['c','alarm','Do not close the tab. I get emotional.'],
      ['c','nod','This is the part where you press the button.']
    ],
    cartEmpty: [
      ['c','roll','The cart is empty. Much like my weekends.'],
      ['c','sigh','Nothing in here yet. I am choosing not to take it personally.']
    ],
    product: [
      ['r','gasp','Look at the pictures! Click the little ones! They get big!'],
      ['r','grin','I sat on this one. Quality control. It passed.'],
      ['r','tilt','Is this the one? It feels like the one.'],
      ['c','blink','It is still there. It has not moved.'],
      ['c','sus','Read the size chart. I am begging you. Rusty did not.'],
      ['c','scheme','Scroll down. The details are where I hide the good sentences.'],
      ['c','roll','Personalized ones take a few extra days. Worth it, I am told.'],
      ['c','sus','Pairs well with a sofa and not answering emails.']
    ],
    spooky: [
      ['r','gasp','SPOOKY! I am not scared. I am under the desk for other reasons.'],
      ['r','guilty','I tried to wear one as a ghost costume. I could not see. I hit a wall.'],
      ['c','sus','Goth decor. For people who own at least one black candle. Or forty.'],
      ['c','scheme','Halloween is the only holiday where my face fits right in.']
    ],
    xmas: [
      ['r','gasp','Is it Christmas? Is it Christmas yet? Is it Christmas NOW?'],
      ['r','wiggle','I wrapped myself as a present. Nobody opened me.'],
      ['c','roll','It is not December. He has been like this since August.'],
      ['c','scheme','Order early. The elves are already behind.']
    ],
    personal: [
      ['r','gasp','You can put your name on it! I put my name on everything. Also on Cash.'],
      ['r','tilt','What if your name was Rusty? That would be the best blanket.'],
      ['c','sus','Personalized. Because nothing says family like arguing over whose name goes first.'],
      ['c','scheme','Check the spelling twice. We print exactly what you type. Exactly.']
    ],
    crackers: [
      ['r','gasp','They go BANG! I love bang!'],
      ['r','guilty','I pulled one early. I got a paper hat. Worth it.'],
      ['c','alarm','They pop. He knows they pop. He still screams every time.'],
      ['c','sus','Handmade. Not by him. Nothing good is handmade by him.']
    ],
    love: [
      ['r','gasp','Love! Two people! One blanket! That is so much love!'],
      ['c','roll','Til death. Or til someone steals the whole blanket. Usually sooner.'],
      ['c','scheme','A gift they will actually use. Unlike the salad spinner.']
    ],
    blanket: [
      ['r','tilt','I tested every blanket. For science. Mostly naps.'],
      ['c','sus','Heavy. Cozy. Hard to leave. Ask Rusty, he has not moved since June.']
    ],
    apparel: [
      ['r','wiggle','I tried it on. It fit my head. That counts.'],
      ['c','sus','Wearable. Washable. More than can be said for most of us.']
    ],
    funny: [
      ['r','mic','Is this thing on? It is on. I am hilarious.'],
      ['r','mic','Two dogs walk into a shop. That is the joke. Thank you.'],
      ['c','sigh','He has been doing the bit for an hour.']
    ],
    ornament: [
      ['r','gasp','It is shiny! Can I put it on my tail?'],
      ['c','sus','An ornament. Hang it high. Rusty is coming.']
    ],
    search: [
      ['r','tilt','What are we looking for? I will help. I am bad at finding things.'],
      ['c','sus','Searching. Bold. Most people just hope.']
    ],
    searchNone: [
      ['c','palm','Nothing. Rusty may have eaten it. Try another word.'],
      ['r','guilty','It is not here. I did not eat it. I might have eaten it.']
    ],
    notfound: [
      ['r','guilty','I broke this page. I did not mean to. I did mean to lean on it.'],
      ['c','palm','This page is gone. We do not talk about what happened.']
    ],
    night: [
      ['r','tilt','Why are we awake? Is this a sleepover?'],
      ['c','blink','Shopping at this hour. Bold. I am also awake. Obviously.']
    ],
    morning: [
      ['r','wiggle','Good morning! I had breakfast twice!'],
      ['c','roll','It is early. I do not drink coffee. It is still early.']
    ],
    weekend: [
      ['c','sus','It is the weekend. I am working. Rusty thinks he is working.']
    ],
    hover: [
      ['r','gasp','Ooh, {t}! I have not seen the others but that one. Yes.'],
      ['r','wiggle','{t}? Great choice. I would lie down on it.'],
      ['c','nod','{t}. Yes. That one. I have a feeling.'],
      ['c','scheme','You keep looking at {t}. I am not saying anything. I am saying something.']
    ]
  };

  /* ---------- CONTEXT ---------- */
  var d = root.dataset;
  var tpl = d.template || '';
  var text = ((d.handle || '') + ' ' + (d.ptype || '') + ' ' + (d.ptags || '') + ' ' + (d.title || '')).toLowerCase();
  var ctx = [];
  function has(re) { return re.test(text); }
  if (tpl === 'index') ctx.push('home');
  if (tpl === 'product') ctx.push('product');
  if (tpl === 'search') ctx.push(d.results === '0' && d.terms ? 'searchNone' : 'search');
  if (tpl === '404') ctx.push('notfound');
  if (tpl === 'cart') ctx.push(+d.cart > 0 ? 'cart' : 'cartEmpty');
  if (has(/hallowe|spook|goth|witch|skull|bat/)) ctx.push('spooky');
  if (has(/christmas|xmas|holiday|santa|noel/)) ctx.push('xmas');
  if (has(/personal|family|name|custom/)) ctx.push('personal');
  if (has(/cracker/)) ctx.push('crackers');
  if (has(/wedding|couple|love|valentine|til death|anniversar/)) ctx.push('love');
  if (has(/blanket|throw|sherpa|fleece/)) ctx.push('blanket');
  if (has(/shirt|tee|hoodie|sweatshirt|apparel/)) ctx.push('apparel');
  if (has(/funny/)) ctx.push('funny');
  if (has(/ornament/)) ctx.push('ornament');
  var hr = new Date().getHours(), day = new Date().getDay();
  if (hr >= 23 || hr < 4) ctx.push('night');
  if (hr >= 5 && hr < 9) ctx.push('morning');
  if (day === 0 || day === 6) ctx.push('weekend');
  var visits = 0;
  try { visits = +(localStorage.getItem('pw-visits') || 0) + (sessionStorage.getItem('pw-v') ? 0 : 1); localStorage.setItem('pw-visits', visits); sessionStorage.setItem('pw-v', '1'); } catch (e) {}
  if (visits > 1) ctx.push('returning');
  var cashOnly = tpl === 'cart';

  /* ---------- MEMORY: never repeat until the pool runs dry ---------- */
  var seen = {};
  try { (JSON.parse(localStorage.getItem('pw-seen') || '[]')).forEach(function (k) { seen[k] = 1; }); } catch (e) {}
  function key(l) { return l[0] + l[2].slice(0, 24); }
  function remember(l) {
    seen[key(l)] = 1;
    try { var a = Object.keys(seen); localStorage.setItem('pw-seen', JSON.stringify(a.slice(-140))); } catch (e) {}
  }
  function pickFrom(names) {
    var pool = [];
    names.forEach(function (n) { (L[n] || []).forEach(function (l) {
      if (cashOnly && l[0] !== 'c') return;
      if (l[1] === 'sign') return;
      if (tpl === 'product' && innerWidth < 750) return;
      pool.push(l);
    }); });
    if (!pool.length) return null;
    var fresh = pool.filter(function (l) { return !seen[key(l)]; });
    if (!fresh.length) { pool.forEach(function (l) { delete seen[key(l)]; }); fresh = pool; }
    return fresh[Math.floor(Math.random() * fresh.length)];
  }

  /* ---------- GREEN SCREEN KEYER (WebGL) ---------- */
  var VS='attribute vec2 p;varying vec2 u;void main(){u=vec2(p.x*.5+.5,.5-p.y*.5);gl_Position=vec4(p,0.,1.);}';
  var FS='precision mediump float;varying vec2 u;uniform sampler2D t;void main(){vec4 c=texture2D(t,u);float m=max(c.r,c.b);float k=c.g-m;float a=1.-smoothstep(.10,.28,k);vec3 col=c.rgb;col.g=min(col.g,m+.04);gl_FragColor=vec4(col*a,a);}';
  function Keyer(canvas){
    this.c=canvas;var g=null;
    try{g=canvas.getContext('webgl',{premultipliedAlpha:true,alpha:true});}catch(e){}
    this.g=g;
    if(!g)return;
    function sh(tp,src){var o=g.createShader(tp);g.shaderSource(o,src);g.compileShader(o);return o;}
    var pr=g.createProgram();g.attachShader(pr,sh(g.VERTEX_SHADER,VS));g.attachShader(pr,sh(g.FRAGMENT_SHADER,FS));g.linkProgram(pr);g.useProgram(pr);
    var b=g.createBuffer();g.bindBuffer(g.ARRAY_BUFFER,b);g.bufferData(g.ARRAY_BUFFER,new Float32Array([-1,-1,1,-1,-1,1,1,1]),g.STATIC_DRAW);
    var l=g.getAttribLocation(pr,'p');g.enableVertexAttribArray(l);g.vertexAttribPointer(l,2,g.FLOAT,false,0,0);
    var tx=g.createTexture();g.bindTexture(g.TEXTURE_2D,tx);
    [g.TEXTURE_WRAP_S,g.TEXTURE_WRAP_T].forEach(function(w){g.texParameteri(g.TEXTURE_2D,w,g.CLAMP_TO_EDGE);});
    g.texParameteri(g.TEXTURE_2D,g.TEXTURE_MIN_FILTER,g.LINEAR);g.texParameteri(g.TEXTURE_2D,g.TEXTURE_MAG_FILTER,g.LINEAR);
  }
  Keyer.prototype.clear=function(){var g=this.g;if(!g)return;g.viewport(0,0,this.c.width,this.c.height);g.clearColor(0,0,0,0);g.clear(g.COLOR_BUFFER_BIT);};
  Keyer.prototype.draw=function(src){
    var g=this.g;if(!g)return;
    this.clear();
    try{g.texImage2D(g.TEXTURE_2D,0,g.RGBA,g.RGBA,g.UNSIGNED_BYTE,src);}catch(e){return;}
    g.drawArrays(g.TRIANGLE_STRIP,0,4);
  };
  var imgCache={};
  function loadImg(url,cb){
    if(imgCache[url]&&imgCache[url].complete)return cb(imgCache[url]);
    var i=new Image();i.crossOrigin='anonymous';i.onload=function(){cb(i);};i.src=url;imgCache[url]=i;
  }
  /* one video element per loop, reused across appearances */
  var vidCache={};
  function getVid(url,pre){
    var v=vidCache[url];
    if(!v){v=document.createElement('video');v.muted=true;v.loop=true;v.playsInline=true;v.setAttribute('playsinline','');v.crossOrigin='anonymous';v.preload=pre||'metadata';v.src=url;vidCache[url]=v;}
    else if(pre==='auto')v.preload='auto';
    return v;
  }
  /* empty space under the paws, read off the first frame: fraction of the height to push off screen */
  var autoB={};
  function measureB(v){
    try{
      var c=document.createElement('canvas');c.width=48;c.height=64;var x=c.getContext('2d');x.drawImage(v,0,0,48,64);
      var a=x.getImageData(0,0,48,64).data;
      for(var y=63;y>=0;y--){var n=0;for(var i=0;i<48;i++){var o=(y*48+i)*4;if(a[o+1]-Math.max(a[o],a[o+2])<40)n++;}if(n>1)return Math.max(0,(63-y)/64-.01);}
    }catch(e){}
    return 0;
  }
  function Stage(slot){
    this.cv=slot.querySelector('canvas');this.k=new Keyer(this.cv);this.v=null;this.raf=0;
  }
  Stage.prototype.still=function(url){var s=this;s.stop();loadImg(url,function(i){if(!s.v)s.k.draw(i);});};
  Stage.prototype.play=function(url,onFirst){
    var s=this;if(!s.k.g)return;
    if(s.v&&s.v!==vidCache[url])s.v.pause();
    s.v=getVid(url,'auto');
    try{s.v.currentTime=0;}catch(e){}
    var p=s.v.play();if(p&&p.catch)p.catch(function(){});
    cancelAnimationFrame(s.raf);
    var first=true;
    (function tick(){if(!s.v)return;if(s.v.readyState>=2){s.k.draw(s.v);if(first){first=false;if(onFirst)onFirst(s.v);}}s.raf=requestAnimationFrame(tick);})();
  };
  Stage.prototype.stop=function(){cancelAnimationFrame(this.raf);if(this.v){this.v.pause();this.v=null;}};

  /* ---------- STAGE ---------- */
  var slots = {
    r: root.querySelector('#pw-rusty'),
    c: root.querySelector('#pw-cash')
  };
  var DEF = { r: 'grin', c: 'sus' };
  var lastPose = {};
  var stages = { r: slots.r && new Stage(slots.r), c: slots.c && new Stage(slots.c) };
  function setPose(who, pose) {
    var st = stages[who]; if (!st) return;
    var list = POSES[who] || {};
    if (!list[pose] || !list[pose].v) pose = DEF[who];
    if (SEA && list[SEA] && list[SEA].v && pose !== 'mic' && Math.random() < 0.5) pose = SEA;
    var p = list[pose]; if (!p) return;
    lastPose[who] = pose;
    function lift(b) { st.cv.style.transform = 'translateY(' + ((b || 0) * 100).toFixed(1) + '%)'; }
    lift(p.b != null ? p.b : autoB[p.v]);
    function go() {
      if (lastPose[who] !== pose) return;
      st.play(p.v, function (v) { if (p.b == null && autoB[p.v] == null) { autoB[p.v] = measureB(v); lift(autoB[p.v]); } });
    }
    if (p.f) {
      st.still(CDN + p.f + '?width=' + (devicePixelRatio > 1 ? 600 : 300));
      if (p.v) setTimeout(go, 650);
    } else { st.stop(); st.k.clear(); go(); }
  }
  /* preload the default stills so the first entrance is instant */
  ['r', 'c'].forEach(function (w) { var p = (POSES[w] || {})[DEF[w]]; if (p && p.f) loadImg(CDN + p.f + '?width=' + (devicePixelRatio > 1 ? 600 : 300), function () {}); });
  /* costume loops have no still: start buffering them once the page has settled */
  if (SEA) setTimeout(function () { ['r', 'c'].forEach(function (w) { var p = (POSES[w] || {})[SEA]; if (p && p.v) getVid(p.v, 'auto'); }); }, 6000);
  function say(who, pose, line, hold) {
    var s = slots[who];
    setPose(who, pose);
    var st = s.querySelector('.pw-signtext');
    s.classList.remove('pw-signing');
    if (st) st.textContent = '';
    s.querySelector('.pw-bubble').textContent = line;
    s.classList.remove('pw-out', 'pw-say'); s.classList.add('pw-in');
    setTimeout(function () { s.classList.add('pw-say'); }, 700);
    return setTimeout(function () { out(who); }, 700 + hold);
  }
  function out(who) {
    var s = slots[who]; if (!s.classList.contains('pw-in')) return;
    s.classList.remove('pw-say', 'pw-in'); s.classList.add('pw-out');
    setTimeout(function () { s.classList.remove('pw-out'); if (stages[who]) stages[who].stop(); }, 420);
  }
  /* reading time: a slow reader needs about 4s plus 80ms a character */
  function holdFor(t) { return Math.min(11000, 4200 + t.length * 80); }

  var busy = false, shows = 0, MAX = PDP || MOB ? 1 : 7, lastAt = 0, timer = null, BORN = Date.now();
  /* no WebGL means no keyed video: skip entirely */
  if (stages.r && !stages.r.k.g) { root.remove(); return; }
  function atcInCorner() {
    var b = document.querySelector('form[action*="/cart/add"] [name="add"], .product-form__submit');
    if (!b) return false; var r = b.getBoundingClientRect();
    return r.bottom > 0 && r.top < innerHeight && r.bottom > innerHeight - 200 && (r.left < 160 || r.right > innerWidth - 160);
  }
  function perform(l, vars) {
    if (!l || busy || document.hidden || shows >= MAX) return false;
    if (PDP && (Date.now() - BORN < 20000 || atcInCorner() || (document.activeElement && document.activeElement.closest && document.activeElement.closest('product-form, .product-form, .product__info-container')))) { queue(8000); return false; }
    if (MOB) { try { sessionStorage.setItem('pw-m-shown', '1'); } catch (e) {} }
    busy = true; shows++; lastAt = Date.now(); remember(l);
    var txt = l[2];
    if (vars) txt = txt.replace('{t}', vars.t);
    var done;
    if (l[0] === 'b') {
      var parts = txt.split('|');
      var first = holdFor(parts[0]);
      say('r', 'grin', parts[0], first + holdFor(parts[1]));
      setTimeout(function () { say('c', 'sus', parts[1], holdFor(parts[1])); }, first);
      done = first + 700 + holdFor(parts[1]) + 500;
    } else {
      say(l[0], l[1], txt, holdFor(txt));
      done = 700 + holdFor(txt) + 500;
    }
    setTimeout(function () { busy = false; queue(); }, done);
    return true;
  }
  function ambient() {
    var names = ctx.slice();
    /* context lines are 3x as likely as general ones */
    var l = Math.random() < 0.7 && names.length ? pickFrom(names) : null;
    if (!l) l = pickFrom(cashOnly ? ['cart', 'cartEmpty', 'any'] : ['any']);
    perform(l);
  }
  function queue(ms) {
    clearTimeout(timer);
    timer = setTimeout(ambient, ms || 36000 + Math.random() * 44000);
  }
  function react(name, vars) {
    if (busy || PDP || Date.now() - lastAt < 16000) return;
    clearTimeout(timer);
    perform(pickFrom([name]), vars);
  }

  /* ---------- TRIGGERS ---------- */
  var idleT;
  function poke() { clearTimeout(idleT); idleT = setTimeout(function () { react('idle'); }, 30000); }
  ['scroll', 'mousemove', 'keydown', 'touchstart'].forEach(function (e) { addEventListener(e, poke, { passive: true }); });
  poke();

  var deepDone = false;
  addEventListener('scroll', function () {
    if (deepDone) return;
    var h = document.documentElement;
    if ((scrollY + innerHeight) / h.scrollHeight > 0.75) { deepDone = true; react('deep'); }
  }, { passive: true });

  var hiddenAt = 0;
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) { hiddenAt = Date.now(); clearTimeout(timer); out('r'); out('c'); busy = false; }
    else if (hiddenAt && Date.now() - hiddenAt > 15000) { setTimeout(function () { react('back'); }, 1200); }
    else queue();
  });

  /* add to cart: Dawn posts to /cart/add with fetch */
  var f = window.fetch;
  if (f) window.fetch = function (u) {
    var p = f.apply(this, arguments);
    try { if (String(u && u.url || u).indexOf('/cart/add') > -1) p.then(function (r) { if (r.ok) setTimeout(function () { lastAt = 0; busy = false; react('atc'); }, 900); }); } catch (e) {}
    return p;
  };

  /* lingering on a product card for 2.5s */
  var hoverT, hoverCard = null;
  document.addEventListener('mouseover', function (e) {
    var card = e.target.closest && e.target.closest('.card-wrapper, .product-card-wrapper');
    if (!card || card === hoverCard) return;
    hoverCard = card; clearTimeout(hoverT);
    hoverT = setTimeout(function () {
      var a = card.querySelector('.card__heading a, .card__heading');
      var t = a ? a.textContent.trim().replace(/\s+/g, ' ') : '';
      if (!t) return;
      if (t.length > 38) t = t.slice(0, 36).replace(/\s\S*$/, '') + '...';
      react('hover', { t: t });
    }, 2500);
  });
  document.addEventListener('mouseout', function (e) { var c = e.target.closest && e.target.closest('.card-wrapper, .product-card-wrapper'); if (c && !c.contains(e.relatedTarget)) { clearTimeout(hoverT); hoverCard = null; } });

  /* hover retreats, click dismisses for the session */
  ['r', 'c'].forEach(function (w) {
    var s = slots[w]; if (!s) return;
    var img = s.querySelector('canvas');
    img.addEventListener('mouseenter', function () { out(w); });
    img.addEventListener('click', function () {
      try { sessionStorage.setItem('pw-peek-off', '1'); } catch (e) {}
      out('r'); out('c'); clearTimeout(timer); setTimeout(function () { root.remove(); }, 600);
    });
  });

  window.PWCast = { react: react, perform: perform, L: L, ctx: ctx, season: SEA };
  queue(PDP ? 20000 + Math.random() * 10000 : (visits > 1 ? 12000 : 15000));
})();
